import { tracker } from "@openreplay/tracker";
import React, { useState } from "react";

import { ASSISTANT_EVENTS } from "@helpers/events";

import FloatingAssistantBubble from "./FloatingAssistantBubble";
import FloatingAssistantWindow from "./FloatingAssistantWindow";

const FloatingAssistant: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => {
    tracker.event(ASSISTANT_EVENTS.FLOATING_BUBBLE_OPENED);
    setIsOpen(true);
  };

  const handleMinimize = () => {
    tracker.event(ASSISTANT_EVENTS.FLOATING_WINDOW_MINIMIZED);
    setIsOpen(false);
  };

  return (
    <>
      <FloatingAssistantBubble onClick={handleOpen} isOpen={isOpen} />
      <FloatingAssistantWindow isOpen={isOpen} onMinimize={handleMinimize} />
    </>
  );
};

export default FloatingAssistant;
